
export default {
  name: 'AppDialog',
  props: {
    showCloseButton: { type: Boolean, default: true }
  }
};
